module.exports = __webpack_public_path__ + "media/images/admin/icons/bluetooth-4e0cbf9069a8de16e558d73d3c37d779.svg";